import { initStackedBarChartMonthSeries } from 'vlcishared';
import { printDataChart, printNoDataChart } from '../common';

export function echartUsuarisTotalsStackedBarYears(vis, datos) {
  if (datos.resultset.length === 0) {
    printNoDataChart(
      '#chartUsuarisTotalsStackedBarYears',
      '#no_dataUsuarisTotalsStackedBarYears',
    );
  } else {
    printDataChart(
      '#no_dataUsuarisTotalsStackedBarYears',
      '#chartUsuarisTotalsStackedBarYears',
    );

    const updateOptions = {
      title: {
        text: "ÚS D'EMT. USUARIS TOTALS: DESGLOSSAMENT DELS ÚLTIMS ANYS",
      },
      xAxis: {
        name: '\n\n\n\nViatges',
      },
    };
    initStackedBarChartMonthSeries(
      'chartUsuarisTotalsStackedBarYears',
      datos.resultset,
      updateOptions,
    );
  }
}
